// @flow
import * as React from 'react';
import cx from 'classnames';
import NavigateLink from 'app/common/react/ui/NavigateLink';

type Props = {|
  html: string,
  onClick?: Function,
|};

const SAFE_LINK_FLAG = '__SafeLinkFlag__';

const SafeLinkHTML = ({ html, onClick }: Props) => {
  const navigateClick = onClick || null;
  const links = [];
  html = html || '';
  // Replace hashtags with links to hashtag feed
  html = html.replace(/#[^(\-\\.\s#,\/$%\^&\*;:{}=\`~()\[\]@|<>)]+/gi, (hashtag) => {
    links.push({
      url: `/search/pins/?q=${encodeURIComponent(hashtag)}&rs=hashtag_closeup`,
      text: hashtag,
    });
    return SAFE_LINK_FLAG;
  });

  const encodedHTML = html.replace(
    /<a[\s]+href=['"]([^'"<>]+)['"][^>]*>([^<]*)<\/a>/gi,
    (anchorHTML, url, text) => {
      links.push({ url, text });
      return SAFE_LINK_FLAG;
    },
  );

  const linkClassName = cx({
    blue: true,
    'inline-block': true,
  });

  return (
    <div data-test-id="safe-link">
      {encodedHTML
        .split(new RegExp(`(${SAFE_LINK_FLAG})`))
        .filter((str) => str.length > 0)
        .map((str, index) => {
          let content = str;
          if (str === SAFE_LINK_FLAG && links.length) {
            const { url, text } = links.shift();
            content = (
              <NavigateLink onClick={navigateClick} to={url} className={linkClassName}>
                {text}
              </NavigateLink>
            );
          }
          return <span key={index}>{content}</span>;
        })}
    </div>
  );
};

export default SafeLinkHTML;
